import React from 'react'
import { JsonViewer } from '@ztechapps/webui.util'

export const QueryTemplateDisplayValue = ({ value }) => {
  return (
    <small>
      <JsonViewer data={value} collapsed={false} />
    </small>
  )
}
